import 'css-chunksrc/client/pages/projectPage/synthesisPage/monitoring/milestones/styles.scss';export default {
  "milestones": "_milestones_1egf6_1",
  "timeline": "_timeline_1egf6_8",
  "list": "_list_1egf6_21",
  "milestone": "_milestone_1egf6_1",
  "today": "_today_1egf6_40",
  "dates": "_dates_1egf6_46",
  "date": "_date_1egf6_46"
};